<template>
    <div class="item_header">
        <div class="item_header--title">
            {{ item.name }}
        </div>
        <div class="item_header--duration" v-if="item.duration !== undefined">
            {{ item.duration }}
        </div>
    </div>
    <div class="item_time">
        <div class="item_time--icon">
            <img src="../assets/img/calendar.svg" alt="">
        </div>
        <div class="item_type--text">
            {{ item.time }}
        </div>
    </div>
    <div class="item_description" v-if="item.description !== undefined">
        {{ item.description }}
    </div>
    <div class="item_data">
        <div class="item_data--row" v-if="item.end_date">
            <div class="key">
                <i>
                    <img src="../assets/img/sand_clock.png">
                </i>
                Срок действия
            </div>
            <div class="value">
                {{ contractEndDate }}
            </div>
        </div>
        <div class="item_data--row">
            <div class="key">
                <i>
                    <img src="../assets/img/run.png">
                </i>
                Посещений осталось
            </div>
            <div class="value">
                {{ contractVisits }}
            </div>
        </div>
        <div class="item_data--row">
            <div class="key">
                <i>
                    <img src="../assets/img/sand_clock.png">
                </i>
                Заморозка
            </div>
            <div class="value">
                {{ contractFreezeDays }}
            </div>
        </div>
        <div class="item_data--row">
            <div class="key">
                <i>
                    <img src="../assets/img/peace.png">
                </i>
                Гостевые визиты
            </div>
            <div class="value">
                {{ contractGuests }}
            </div>
        </div>
    </div>
    <div class="item_price">
        <div class="item_price--key">
            Итого
        </div>
        <div class="item_price--value">
            <currency-symbol :price="item.price_full"/>
        </div>
    </div>
    <div
        class="item_status"
        :class="'item_status--'+ contractStatusClass"
        v-if="contractStatusClass !== 'hide'"
    >
        {{ contractStatusMessage }}
    </div>
    <div
        class="item_status item_status--primary item_cancel_recurrent"
        v-if="contractCanCancelSubscription"
        @click="openCancelSubscriptionModal"
    >
        Отменить подписку
    </div>
</template>

<script>
    import moment from "moment";
    import { plural } from "../utilities/index"
    import CurrencySymbol from "./CurrencySymbol";

    export default {
        name: "ContractItem",
        components: {CurrencySymbol},
        props: {
            item: {},
        },
        computed: {
            contractEndDate() {
                return moment(this.item.end_date, 'YYYY-MM-DD').format('DD.MM.YYYY ');
            },
            contractVisits() {
                return this.item.visits_left !== null ? this.item.visits_left + ' из ' + this.item.visits_total : 'Не ограничено';
            },
            contractFreezeDays() {
                return plural(this.item.freeze_days_left, ['день', 'дня', 'дней'])
            },
            contractGuests() {
                return this.item.guests_left + ' шт.'
            },
            contractStatusClass() {
                if (this.item.payment === false){
                    return 'danger'
                }
                if (this.item.end_date === null){
                    return 'warning'
                }

                return 'hide'
            },
            contractStatusMessage(){
                if (this.item.payment === false){
                    return 'Не оплачено'
                }
                if (this.item.end_date === null){
                    return 'Активация при посещении'
                }

                return ''
            },
            contractCanCancelSubscription() {
                return this.$store.getters.settings.modules && this.$store.getters.settings.modules.subscription.cancel.enable && this.item.reccurent.enable;
            },
        },
        methods: {
          openCancelSubscriptionModal() {
            this.$store.commit('SHOW_MODAL_PRELOADER')
            this.$store.commit('SET_ITEM_CANCEL_SUBSCRIPTION_MODAL', this.item);
            this.$store.commit('HIDE_MODAL_PRELOADER')
          },
        },
    }
</script>